import { Lightning } from '@lightningjs/sdk'
import { TvButtonModel } from '../../types/flo-experience'
import Button from './button'

export class Buttons extends Lightning.Component {
  private _buttons: TvButtonModel[]
  private _totalBtns = 0
  private _buttonIndex = 0

  static _template() {
    return {
      rtt: true,
      flex: { direction: 'row' },
      collision: true,
    }
  }

  set buttons(v: TvButtonModel[]) {
    this._buttons = v
    this._totalBtns = v.length
    this.renderButtons(v)
  }

  get currentButton() {
    return this.childList.getAt(this._buttonIndex) as Button
  }

  _getFocused() {
    return this.currentButton
  }

  _handleLeft() {
    if (this._buttonIndex === 0) {
      return false
    } else {
      this._buttonIndex--
    }
  }

  _handleRight() {
    if (this._buttonIndex === this._totalBtns - 1) {
      return false
    } else {
      this._buttonIndex++
    }
  }

  renderButtons(btnArray: TvButtonModel[]) {
    const children = btnArray.map((btn, index) => {
      return {
        type: Button,
        data: btn,
        buttonIndex: index,
        padding: 70,
        adjustWidthToContent: true,
      }
    })

    this.patch({ children })
  }
}
